import React from "react";
import { Avatar, Typography, makeStyles } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  avatarRing: {
    padding: 3,
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, #ff7a5c 100%)`,
    display: "inline-flex",
    marginBottom: theme.spacing(1.5),
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
    border: "3px solid #F7F8FA",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 4px 16px rgba(233, 58, 36, 0.28)",
    },
  },
  name: {
    marginTop: 0,
    fontWeight: 600,
    fontSize: "0.95rem",
    letterSpacing: "0.01em",
    textAlign: "center",
  },
  email: {
    marginTop: theme.spacing(0.25),
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    opacity: 0.7,
    textAlign: "center",
  },
  installerBadge: {
    marginTop: theme.spacing(0.75),
    fontSize: "0.68rem",
    background: "rgba(233, 58, 36, 0.1)",
    color: theme.palette.primary.main,
    padding: "2px 10px",
    borderRadius: 12,
    fontWeight: 600,
    letterSpacing: "0.03em",
    display: "inline-block",
  },
}));

const UserAvatar = ({ user }) => {
  const classes = useStyles();

  return (
    <>
      <span className={classes.avatarRing}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          to="/app/account"
        />
      </span>
      {user ? (
        <>
          <Typography className={classes.name} color="textPrimary" variant="h5">
            {user.first_name} {user.last_name}
          </Typography>
          <Typography className={classes.email} variant="body2">
            {user.email}
          </Typography>
          {user.profile.id_installer ? (
            <span className={classes.installerBadge}>
              ID {user.profile.id_installer}
            </span>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default UserAvatar;
